export default function($) {
  $('.form-error').attr('aria-invalid', 'true');

  const $formFields = $('input:not([type="hidden"]), select, textarea');

  $formFields.on('invalid', function() {
    $(this).attr('aria-invalid', 'true');
  });

  $formFields.on('input change', function() {
    if (this.checkValidity()) {
      $(this).removeAttr('aria-invalid');
    } else {
      $(this).attr('aria-invalid', 'true');
    }
  });

  $('.geolocation').on('click', function() {
    if (!navigator.geolocation) return;

    const $btn = $(this);
    const $input = $btn.closest('form').find('input[name="s"], input[name="localisation"]').first();

    $btn.attr('disabled', true).addClass('opacity-50');

    const done = () => $btn.removeAttr('disabled').removeClass('opacity-50');

    navigator.geolocation.getCurrentPosition(
      function(position) {
        const { latitude, longitude } = position.coords;

        if (typeof google !== 'undefined' && google.maps && google.maps.Geocoder) {
          new google.maps.Geocoder().geocode(
            { location: { lat: latitude, lng: longitude } },
            function(results, status) {
              if (status === 'OK' && results[0]) {
                $input.val(results[0].formatted_address).trigger('input');
                // Also fill hidden coord inputs so the controller skips server-side geocoding.
                const form = $input.closest('form')[0];
                if (form) {
                  const latInput = form.querySelector('input[name="location-lat"]');
                  const lngInput = form.querySelector('input[name="location-lng"]');
                  if (latInput) latInput.value = latitude;
                  if (lngInput) lngInput.value = longitude;
                }
              }
              done();
            }
          );
        } else {
          fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`)
            .then(res => res.json())
            .then(data => {
              const city = data.address.city || data.address.town || data.address.village || data.address.municipality || '';
              $input.val(city);
            })
            .catch(() => {})
            .finally(done);
        }
      },
      done
    );
  });
}
